import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityHoldPostprocessingDialogComponent } from './security-hold-postprocessing-dialog.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PaymentElementModule } from '../../../../shared/payment-element/payment-element.module';

@NgModule({
  declarations: [SecurityHoldPostprocessingDialogComponent],
  imports: [CommonModule, SharedModule, PaymentElementModule],
})
export class SecurityHoldPostprocessingDialogModule {}
